import * as _ from 'lodash'
import { defineComponent } from 'vue'
import { faPlus, faLock, faLockOpen, faLocationArrow, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

import { Container } from '@skinsoft/types'
import { TrackingRoutes } from '@skinsoft/const'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import {
    ADD_ITEM_TOPIC,
    CLOSE_CONTAINER_TOPIC,
    CREATE_CONTAINER_TOPIC,
    OPEN_CONTAINER_TOPIC,
    ADD_ACCESSORY_TOPIC,
    ADD_CONTAINER_TOPIC,
    ADD_LOCATION_TOPIC,
    DELETE_CONTAINER_TOPIC,
    ADD_SPECIMEN_TOPIC
} from '../../../../busTopics';

require('./action-menu-container.scss')

export const ActionMenuContainer = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['entityDataStore'],
    template: require('./action-menu-container.html'),
    data() {
        return {
            plusIcon: faPlus,
            lockIcon: faLock,
            lockOpenIcon: faLockOpen,
            locationIcon: faLocationArrow,
            checkIcon: faCheck,
            crossIcon: faTimes,

            entity: null as Container | null,

            canAddItem: false,
            canCreateContainer: false,
            canCloseContainer: false,
            canOpenContainer: false,
            missingLocation: false,
            displayDeleteConfirmation: false,
        }
    },
    created() {
        this.subscribeToEntity();
    },
    methods: {
        subscribeToEntity() {
            if (this.$route.name === TrackingRoutes.CONTAINER) {
                this.subscribeTo(
                    this.entityDataStore.fetchOne(this.$route.params.id),
                    entity => {
                        this.missingLocation = !entity.locationItemSchema?.realTimeLocation
                        this.canOpenContainer = !entity.containerItemSchema.openContainer
                        this.canCloseContainer = !this.canOpenContainer
                        this.canAddItem = entity.containerItemSchema.openContainer
                        this.entity = entity
                    },
                    'entity',
                );
            } else {
                this.canCreateContainer = true
            }
        },

        addItem() {
            this.emitOnBus(ADD_ITEM_TOPIC)
            this.$emit('toggle')
        },

        addSpecimen() {
            this.emitOnBus(ADD_SPECIMEN_TOPIC)
            this.$emit('toggle')
        },

        addAccessory() {
            this.emitOnBus(ADD_ACCESSORY_TOPIC)
            this.$emit('toggle')
        },

        addContainer() {
            this.emitOnBus(ADD_CONTAINER_TOPIC)
            this.$emit('toggle')
        },

        createContainer() {
            this.emitOnBus(CREATE_CONTAINER_TOPIC)
            this.$emit('toggle')
        },

        closeContainer() {
            this.emitOnBus(CLOSE_CONTAINER_TOPIC)
            this.$emit('toggle')
        },

        openContainer() {
            this.emitOnBus(OPEN_CONTAINER_TOPIC)
            this.$emit('toggle')
        },

        addLocation() {
            this.emitOnBus(ADD_LOCATION_TOPIC)
            this.$emit('toggle')
        },

        deleteContainer() {
            this.emitOnBus(DELETE_CONTAINER_TOPIC)
            this.$emit('toggle')
        },

        showDeleteConfirmation(value: boolean) {
            this.displayDeleteConfirmation = value
        },
    },
})
